import styled, { css } from "styled-components";

const styles = css`
    display: inline-block;
    font-size: inherit;
    border: ${props => props.theme.button.basic.border};
    padding: ${props => props.theme.button.basic.padding};
    border-radius: ${props => props.theme.button.basic.borderRadius};
    color: ${props => props.theme.button.basic.color};
    background-color: ${props => props.theme.button.basic.backgroundColor};
    text-transform: ${props => props.theme.button.basic.textTransform};
    text-align: center;
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.button.basic.hover.backgroundColor};
    }

    &.accept {
      border: ${props => props.theme.button.accept.border};
      color: ${props => props.theme.button.accept.color};
      background-color:${props => props.theme.button.accept.backgroundColor};
      &:hover {
        background-color: ${props => props.theme.button.accept.hover.backgroundColor};
      }
    }

    &.reject {
      border: ${props => props.theme.button.reject.border};
      color: ${props => props.theme.button.reject.color};
      background-color:${props => props.theme.button.reject.backgroundColor};
      &:hover {
        background-color: ${props => props.theme.button.reject.hover.backgroundColor};
      }
    }
    &:disabled,
    &[disabled] {
      color: black;
      background-color: darkgray;
      &:hover {
        color: black;
        background-color: darkgray;
      }
    }
`
export default styled.button`${styles}`;